<h2>Weekrapport {{ field === 'user_id' ? 'personeel' : 'materieel' }}</h2>
@if (groupTotals?.length === 0 && !print) {
    <p>Er zijn geen uren geboekt in week {{ beginDate | date: 'w yyyy' }} op project {{ projectId }}.</p>
}
@for (userGroupTotal of groupTotals | filter: true : 'visible' : false : trigger; track userGroupTotal) {
    <div class="user-table">
        <table class="table">
            <tr>
                <th class="name">
                    {{ userGroupTotal.group }}
                </th>
                @if (!onlyWeekTotals) {
                    @for (day of customDates; track day) {
                        <th class="day" matTooltip="{{ day.date | date: 'EEE dd MMM y' }}">
                            {{ day.date | date: 'EEE' }}
                        </th>
                    }
                }
                <th class="total">Totaal</th>
            </tr>
            @for (userTotals of userGroupTotal.totals; track userTotals) {
                <tr>
                    <td class="name">
                        {{ userTotals.name }}
                    </td>
                    @if (!onlyWeekTotals) {
                        @for (day of userTotals.days; track day) {
                            <td class="day">
                                @if (day.total > 0) {
                                    {{ day.total | minutes }}
                                }
                            </td>
                        }
                    }
                    <td class="total">
                        {{ userTotals.weekTotal | minutes }}
                    </td>
                </tr>
            }
            @if (!print) {
                <tr class="add-row">
                    <td class="bg-white" colspan="7"></td>
                    <td (click)="registrationsTomanual(userGroupTotal.group)" colspan="2">Overnemen</td>
                </tr>
            }
        </table>
    </div>
}

@if (weekComment?.content?.customs[field]) {
    @for (
        customGroup of weekComment.content.customs[field] | filter: true : 'removed' : true : trigger;
        track customGroup
    ) {
        <div class="user-table">
            <table
                class="table"
                #groupTable
                [cdkDropListData]="customGroup.rows"
                [id]="customGroup.group"
                [cdkDropListConnectedTo]="lists"
                (cdkDropListDropped)="drop($event)"
                cdkDropList>
                @if (!print || customGroup.rows?.length) {
                    <tr>
                        <th class="name" [class.input]="!print">
                            @if (!print) {
                                <input
                                    [(ngModel)]="customGroup.group"
                                    (ngModelChange)="checkChange()"
                                    name="groupname"
                                    placeholder="Naam van groep"
                                    autocomplete="groupname"
                                    type="text" />
                            }
                            @if (print) {
                                {{ customGroup.group }}
                            }
                        </th>
                        @if (!onlyWeekTotals) {
                            @for (day of customDates; track day) {
                                <th
                                    class="day"
                                    (click)="updateGroupDay(customGroup.group, day.abbrev)"
                                    matTooltip="{{ day.date | date: 'EEE dd MMM y' }}">
                                    @if (
                                        (customGroup | groupDayChanges: groupTotals : day.abbrev : field : trigger) &&
                                        !print
                                    ) {
                                        <i
                                            class="fa fa-exclamation-triangle"
                                            matTooltip="Deze handmatige groep overschrijft de regels uit de urenregistratie"></i>
                                    }
                                    {{ day.date | date: 'EEE' }}
                                </th>
                            }
                        }
                        <th class="total">Totaal</th>
                        @if (!print) {
                            <td class="delete" (click)="removeGroup(customGroup)">
                                <i class="far fa-trash"></i>
                            </td>
                        }
                    </tr>
                }
                @for (userTotals of customGroup.rows; track userTotals) {
                    <tr cdkDrag>
                        <td class="name drag" [class.input]="!print">
                            <div class="d-flex align-items-center">
                                @if (!print) {
                                    <div class="pl-1 curpoint" cdkDragHandle>
                                        <i class="fa-solid fa-grip-lines"></i>
                                    </div>

                                    <input
                                        class="employeename"
                                        [(ngModel)]="userTotals.name"
                                        (ngModelChange)="checkChange()"
                                        name="employeename"
                                        placeholder="Naam"
                                        autocomplete="employeename"
                                        type="text" />
                                }
                                @if (print) {
                                    {{ userTotals.name }}
                                }
                            </div>
                        </td>
                        @if (!onlyWeekTotals) {
                            @for (day of customDates; track day) {
                                <td class="day" [class.input]="!print">
                                    @if (!print) {
                                        <app-minutes-input
                                            [(ngModel)]="userTotals[day.abbrev]"
                                            [limitHours]="1000"
                                            (ngModelChange)="checkChange()"
                                            placeholder="-"></app-minutes-input>
                                    }
                                    @if (print && userTotals[day.abbrev] && userTotals[day.abbrev] !== 0) {
                                        {{ userTotals[day.abbrev] | minutes }}
                                    }
                                </td>
                            }
                        }
                        <td class="total">
                            {{ [userTotals] | sum: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] | minutes }}
                        </td>
                        @if (!print) {
                            <td class="delete" (click)="removeRow(customGroup, userTotals)">
                                <i class="far fa-trash"></i>
                            </td>
                        }
                    </tr>
                }
                @if (!print) {
                    <tr class="add-row">
                        <td class="with-btn" [attr.colspan]="onlyWeekTotals ? 3 : 4">
                            <button (click)="addRow(customGroup, groupTable)">Toevoegen</button>
                        </td>
                        <td class="bg-white"></td>
                        <td [attr.colspan]="onlyWeekTotals ? 4 : 5" (click)="registrationsTomanual(customGroup.group)">
                            <i
                                class="fa fa-exclamation-triangle"
                                matTooltip="Deze handmatige groep overschrijft de regels uit de urenregistratie"></i>
                            Bijwerken
                        </td>
                    </tr>
                }
            </table>
        </div>
    }
}
@if (!print) {
    <div class="d-flex justify-content-between mb-5">
        <button (click)="addCustomGroup(weekComment?.content?.customs[field])" mat-raised-button color="primary">
            Groep toevoegen
        </button>
        <div>
            @if ((project?.realisation_times | filter: (beginDate | date: 'w') : 'week' : true)?.length) {
                <button class="me-1" [matMenuTriggerFor]="menu" mat-raised-button color="primary">
                    Overnemen toevoegingen
                </button>
            }
            <mat-menu #menu="matMenu">
                @for (week of project.realisation_times | filter: (beginDate | date: 'w') : 'week' : true; track week) {
                    <button (click)="getCustomFromPast(week)" mat-menu-item>van week {{ week.week }}</button>
                }
            </mat-menu>
            <button (click)="registrationsTomanual(null, true)" mat-raised-button color="primary">
                {{ weekComment?.content?.customs[field]?.length ? 'Opnieuw beginnen' : 'Overnemen registraties' }}
            </button>
        </div>
    </div>
}
@if (!noCars && cars?.length) {
    <div class="mb-5">
        <h2>Personenauto's</h2>
        <div>
            <table class="table">
                <tr>
                    <th class="name">Auto</th>
                    <th>Dagen</th>
                </tr>
                @for (car of cars; track car) {
                    <tr>
                        <td class="name">
                            {{ car.entity?.name }}
                        </td>
                        <td>
                            ({{ car.dates?.length }})
                            @for (day of car.dates; track day; let last = $last) {
                                {{ day | date: 'EEE' }}{{ last ? '' : ',' }}
                            }
                        </td>
                    </tr>
                }
            </table>
        </div>
    </div>
}
